import { getBrowserTimeZone } from "../../../lib/date-time";

export interface NotificationTimezoneOption {
  label: string;
  value: string;
}

export const getDefaultNotificationTimezone = (): string => getBrowserTimeZone();

export const getNotificationTimezoneOptions = (): NotificationTimezoneOption[] => {
  const browserTimeZone = getBrowserTimeZone();
  const supportedTimeZones =
    typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function"
      ? Intl.supportedValuesOf("timeZone")
      : [];

  return Array.from(new Set([browserTimeZone, ...supportedTimeZones]))
    .sort((first, second) => first.localeCompare(second))
    .map((value) => ({ label: value, value }));
};
